// Helper: convierte link de Google Drive a URL directo de imagen
export function toDriveDirectUrl(url: string): string {
  if (!url) return url;
  const trimmed = url.trim();
  // Ya es un link directo
  if (trimmed.includes("googleusercontent.com")) {
    return trimmed;
  }
  // Ya tiene formato thumbnail o uc
  if (trimmed.includes("drive.google.com/thumbnail?") || trimmed.includes("drive.google.com/uc?")) {
    return trimmed;
  }
  // Extraer ID del formato /file/d/ID/view
  const fileMatch = trimmed.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
  if (fileMatch) {
    return `https://drive.google.com/thumbnail?id=${fileMatch[1]}\u0026sz=w800`;
  }
  // Formato open?id=ID
  const openMatch = trimmed.match(/[?\u0026]id=([a-zA-Z0-9_-]+)/);
  if (openMatch) {
    return `https://drive.google.com/thumbnail?id=${openMatch[1]}\u0026sz=w800`;
  }
  return trimmed;
}